import React, { useState, useMemo, lazy, Suspense } from "react";
import { useQuery } from "@tanstack/react-query";
import { Container, Grid, Box, CircularProgress } from "@mui/material";
// import { fetchCountries, fetchCities, fetchHotels } from "./api";
import BusBookingForm1 from "./BusBookingform1";

// const ServicesGrid = lazy(() => import("./ServicesGrid"));
// const SpecialOffers = lazy(() => import("./SpecialOffers"));

const BusBookingLanding = () => {

    return (
        <Box sx={{marginTop:'4%'}}>
            {/* Book a Room Component */}
            <Grid>
                <BusBookingForm1/>
            </Grid>
            {/* Services & Special Offers - Lazy Loaded */}
            <Suspense fallback={<CircularProgress />}>
                <Grid sx={{ marginTop: "4%" }}>
                    {/* <ServicesGrid /> */}
                </Grid>
                <Grid sx={{ marginTop: "4%" }}>
                    {/* <SpecialOffers /> */}
                </Grid>
            </Suspense>
        </Box>
    );
};

export default React.memo(BusBookingLanding);
